<template>
  <div>
    <top-bar />
    <MenuItems :user="this.user" :menuSelected="{ addOffer: true }" />
    <div class="menu-mobile">
      <div class="user-mobile">
        <div class="close-menu" @click="openMenu(false)">
          <img src="@/assets/images/x.svg" />
        </div>
        <div class="openNotifications" @click="showModalPopup('modal_popup_mobileNotifications', true)">
          <div class="unread-notifications">
            <span>2</span>
          </div>
          <img src="@/assets/images/clopotel-alb.svg" />
        </div>

        <div id="modal_popup_mobileNotifications" class="modal-popup">
          <div class="modal-popup-content">
            <a @click="showModalPopup('modal_popup_mobileNotifications', false)" class="close-button">
              <img src="@/assets/images/close-button.svg" />
            </a>
            <div class="notifications">
              <!-- <NotificationsBox :notifications="this.companyMessages" /> -->
            </div>
          </div>
        </div>

        <div>
          <img src="@/assets/images/linie.png" />
        </div>
        <div>
          <img src="@/assets/images/settings.png" />
        </div>
        <div>
          <!-- <a href="#">{{ this.customer.name | titleCase }}</a> -->
        </div>
      </div>
      <MenuItems :user="this.user" :menuSelected="{ addOffer: true }" />
    </div>

    <div class="container-right">
      <div :class="{
        content: true,
      }">
        <h1>{{ $t("addOfferName") }}</h1>
        <p>{{ $t("addOfferShortDesc") }}</p>
        <br />

        <div>
          {{ $t("addOfferChooseType") }}
          <a v-for="(entry, index) in this.offerTypes" :key="index" class="choose-type"
            :class="newOffer.type === entry && 'active'" @click="newOffer.type = entry">{{ $t("chooseType_" + entry)
            }}</a>
        </div>

        <div class="addOfferLayout border-box flex-wrap flex-xl-nowrap justify-content-center">
          <div class="container-alb mb-3">
            <div class="container-fluid">
              <div class="row">
                <div class="col-md-3 d-flex justify-content-center">
                  <div class="uploadImageDiv">
                    <div v-if="this.previewImage" class="offer-preview-image"
                      :style="{ 'background-image': `url(${previewImage})` }">
                    </div>
                    <div v-else-if="this.newOffer.id > 0" class="offer-preview-image"
                      :style="{ 'background-image': `url(${this.getImagePath() + 'offers/offer_' + this.newOffer.id + '.png'})` }">
                    </div>
                    <img v-else class="offer-preview-image" :src="require('@/assets/images/offer_0.svg')" />

                    <br />
                    <a @click="$refs.fileInput1.click()" class="uploadFile">
                      {{ $t("uploadImageLabel") }}</a>
                    <input type="file" @input="uploadFile()" ref="fileInput1" style="display: none"
                      accept=".png, .jpg, .jpeg" />
                  </div>
                </div>
                <div class="col-md-9">
                  <div class="row">
                    <div class="col-sm-8 mb-3 d-flex flex-column align-items-baseline justify-content-end">
                      <small class="text-break">{{ $t("productNameLabel") }}</small>
                      <input type="text" required v-model="newOffer.name" class="formedituser w-100" />
                    </div>
                    <div class="col-sm-2 mb-3 d-flex flex-column align-items-baseline justify-content-end">
                      <small>{{ $t("priceLabel") }}</small>
                      <input type="number" required v-model.number="newOffer.price" class="formedituser w-100" />
                    </div>
                    <div class="col-sm-2 mb-3 d-flex flex-column align-items-baseline justify-content-end">
                      <small>{{ $t("currencyLabel") }}</small>
                      <select v-model="newOffer.currency" class="w-100">
                        <option v-for="(entry, index) in currencies" :key="index" :value="entry">
                          {{ entry }}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-sm-4 mb-3" v-if="newOffer.type === 'OFFER'">
                      <small>{{ $t("measureUnitLabel") }}</small>
                      <br />
                      <input type="text" v-model="newOffer.measure_unit" class="formedituser w-100" />
                    </div>
                    <div class="col-sm-4 mb-3">
                      <small>{{ $t("validityStartLabel") }}</small>
                      <br />
                      <date-range class="invoices-filter" :noRanges="true" :single="true" :minDateOrder="minDate"
                        :time="this.period.validity_start_date" @close="validity_start_dateSelected" />
                    </div>
                    <div class="col-sm-4 mb-3">
                      <small>{{ $t("validityEndLabel") }}</small>
                      <br />
                      <date-range class="invoices-filter" :noRanges="true" :single="true" :minDateOrder="minDate"
                        :time="this.period.validity_end_date" @close="validity_end_dateSelected" />
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-sm-12 mb-3">
                      {{ $t("discoutTypeLabel") }}:
                      <!-- // radio button for offer type -->
                      <!-- <input type="checkbox" id="zero" v-model="isDiscount" style="" /> -->
                      <b-form-checkbox v-model="isDiscount" class="d-inline-block ml-1"></b-form-checkbox>
                      <label for="zero">
                        <strong>{{ $t("discoutLabel") }}</strong>
                      </label>

                      <!-- <input type="checkbox" :value="false" id="one" v-model="isDeduction" /> -->
                      <b-form-checkbox v-model="isDeduction" class="d-inline-block ml-2"></b-form-checkbox>
                      <label for="one">
                        <strong>{{ $t("deductionLabel") }}</strong>
                      </label>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-sm-8 mb-3 d-flex flex-column align-items-baseline justify-content-end">
                      <small>{{ $t("discountValueLabel") }}</small>
                      <br />
                      <input type="number" v-model.number="discountValue" class="formedituser w-100" />
                    </div>
                    <div class="col-sm-4 mb-3 d-flex flex-column align-items-baseline justify-content-end">
                      <small>{{ $t("cityLabel") }}</small>
                      <br />
                      <multiselect
                              v-model="newOffer.city"
                              :options="cities"
                              class="margin-top-1rem"
                              :placeholder="$t('selectLabel')"
                              select-label=""
                              selected-label=""
                              deselect-label=""
                            />
                    </div>
                  </div>
                  <div class="row" v-if="newOffer.type !== 'OFFER'">
                    <div class="col-sm-12 mb-9">
                      <small>{{ $t("locationValueLabel") }}</small>
                      <br />
                      <input type="text" v-model="newOffer.location" class="formedituser w-100" />
                    </div>
                  </div>
                  <div class="row" v-if="newOffer.type !== 'OFFER'">
                    <div class="col-sm-4 mb-3">
                      <small>{{ $t("startDateLabel") }}</small>
                      <br />
                      <date-range class="invoices-filter" :noRanges="true" :single="true" :minDateOrder="minDate"
                        @close="startDateSelected" :time="this.period.startDate" />
                    </div>
                    <div class="col-sm-4 mb-3">
                      <small>{{ $t("endDateLabel") }}</small>
                      <br />
                      <date-range class="invoices-filter" :noRanges="true" :single="true" :minDateOrder="minDate"
                        @close="endDateSelected" :time="this.period.endDate" />
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-sm-12 mb-3">
                      <small>{{ $t("detailsLabel") }}</small>
                      <textarea required v-model="newOffer.description" class="formedituser w-100" maxlength="1000"  />
                    </div>
                  </div>
                  <div class="row mb-3">
                    <div class="col-sm-12">
                      <a class="button-all button-orange" @click="submitNewOffer()">{{ $t("saveChangesLabel")
                      }}</a>&nbsp;&nbsp;&nbsp;&nbsp;
                      <a class="resetButton" @click="resetOfferDetails()">{{
                          $t("cancelChangesLabel")
                      }}</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        <div style="margin: 20px">
          <small>{{ $t('previewTitle') + " " + $t('chooseType_' + newOffer.type) }}</small>
          <offer-case :offer="newOffer" :image="previewImage" :isDiscount="isDiscount" :discountValue="discountValue"
            :currency="newOffer.currency" @showDetails="openOfferDetails" :user="this.user" />
        </div>
      </div>
      </div>
    </div>
    <!-- <modal-loading /> -->
    <offer-details-popup :offer="newOffer" :image="previewImage" :isDiscount="isDiscount" :discountValue="discountValue"
      :currency="newOffer.currency" :period="period" :user="this.user" />
    <div id="modal_popup_info" class="modal-popup">
      <div class="modal-popup-content">
        <a @click="showModalPopup('modal_popup_info', false)" class="close-button">
          <img src="@/assets/images/close-button.svg" />
        </a>
        <br/>
        <div v-if="this.error">
          <p v-html="$t('error_' + this.error.code)"></p>
        </div>
        <div v-else>
          <p v-html="$t(this.successMessage)"></p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Cookies from "js-cookie";
import TopBar from "../components/company/TopBar.vue";
import MenuItems from "../components/company/MenuItems.vue";
import OfferCase from "../components/fragments/OfferCase.vue";
import OfferDetailsPopup from "../components/fragments/OfferDetailsPopup.vue";
// import ModalLoading from "../components/fragments/ModalLoading.vue";
import httpServiceCustomer from "@/http/http-customer.js";
import {  BFormCheckbox } from "bootstrap-vue";
import DateRange from "@/components/DateRange.vue";
import moment from "moment";
import validator from "@/plugins/fieldValidation";
import cities from "@/assets/json/orase.js";


export default {
  name: "AddOffer",
  components: {
    TopBar,
    MenuItems,
    OfferCase,
    // ModalLoading,
    "b-form-checkbox": BFormCheckbox,
    DateRange,
    OfferDetailsPopup,
  },
  data() {
    return {
      user: null,
      error: null,
      offerError: null,
      isDiscount: true,
      isDeduction: false,
      discountValue: 0,
      minDate: moment().toDate(),
      successMessage: "",
      period: {
        endDate: [moment().add(1, "month")],
        startDate: [moment()],
        validity_end_date: [moment().add(1, "month")],
        validity_start_date: [moment()],
      },
      cities: cities,
      newOffer: {
        type: "OFFER",
        currency: "lei",
        deduction: 0,
        description:
          "",
        discount: "",
        location: "",
        person: null,
        name: "",
        price: 0,
        measure_unit: "buc",
        city: "",
      },
      previewImage: null,
      offerTypes: ["OFFER", "TRAINING", "EVENT"],

      currencies: ["lei", "eur"],
    };
  },
  methods: {
    submitNewOffer() {
      this.newOffer.discount = this.isDiscount ? this.discountValue : 0;
      this.newOffer.deduction = this.isDiscount ? 0 : this.discountValue;

      let error = false;
      if (!validator.validateOnlyAlphanumeric(this.newOffer.name.trim())) {
        this.error = { code: "OFFER_NAME_INVALID" };
        error = true;
      }
      if (!validator.validateOnlyAlphanumeric(this.newOffer.description.trim())) {
        this.error = { code: "OFFER_DESCRIPTION_INVALID" };
        error = true;
      }
      if (this.newOffer.description.length > 1000) {
        this.error = { code: "OFFER_DESCRIPTION_TOO_LONG" };
        error = true;
      }
      if (this.newOffer.type === "OFFER" && !validator.validateOnlyAlphanumeric(this.newOffer.measure_unit.trim())) {
        this.error = { code: "OFFER_MEASURE_INVALID" };
        error = true;
      }
      // if (!validator.validateMobilePhone(this.user.person.mobile_phone)){
      //   this.error = { code: "EMAIL_INVALID" };
      // }
      // console.log(this.newOffer.deduction > this.newOffer.price);
      if (this.newOffer.deduction > this.newOffer.price) {
        this.error = { code: "PRICE_DEDUCTION" };
        error = true;
      }
      if (this.newOffer.discount > 100) {
        this.error = { code: "PRICE_DISCOUNT" };
        error = true;
      }
      if (this.newOffer.type !== "OFFER" && !validator.validateOnlyAlphanumeric(this.newOffer.location.trim())) {
        this.error = { code: "OFFER_LOCATION_INVALID" };
      }

      if (moment(this.period.validity_start_date[0]).isAfter(moment(this.period.validity_end_date[0]))) {
        this.error = { code: "START_DATE_TOO_BIG" };
        error = true;
      }
      if (this.newOffer.type !== "OFFER" && moment(this.period.startDate[0]).isAfter(moment(this.period.endDate[0]))) {
        this.error = { code: "VALIDITY_START_DATE_TOO_BIG" };
        error = true;
      }
      if (!this.newOffer.image && !this.newOffer.id && !this.newOffer.id > 0) {
        this.error = { code: "IMAGE_MANDATORY" };
        error = true;
      }
      
      if (error) {
        this.showModalPopup("modal_popup_info", true);
        return;
      }
      // this.showModalPopup("modal_popup_loading", true);
      this.newOffer.validity_end_date =
        this.period.validity_end_date[0];
      this.newOffer.validity_start_date =
        this.period.validity_start_date[0];
      this.newOffer.startDate = this.newOffer.type === "OFFER"
        ? this.period.validity_start_date[0]
        : this.period.startDate[0];
      this.newOffer.endDate = this.newOffer.type === "OFFER"
        ? this.period.validity_end_date[0]
        : this.period.endDate[0];

      if (this.newOffer.id > 0) {
        this.updateExistingOffer();
      } else {
        this.saveNewOffer();
      }

    },
    saveNewOffer() {
      httpServiceCustomer.customerService
        .addNewOffer(this.user.id, this.newOffer, Cookies.get("token"))
        .then(function (response) {
          return response;
        })
        .catch((error) => {
          this.error = { code: error.response.code };
          // this.showModalPopup("modal_popup_loading", false);
          this.showModalPopup("modal_popup_info", true);
        })
        .then((response) => {
          if (response.status == 200) {
            this.newOffer = response.data;
            this.error = null;
            this.successMessage = this.$t("addNewOfferSuccess");
            this.resetOfferDetails();
            // this.showModalPopup("modal_popup_loading", false);
            this.showModalPopup("modal_popup_info", true);
          } else {
            this.error = {
              code: response.data.code,
              description: "Error adding offer",
            };
          }
        });
    },
    updateExistingOffer() {
      this.newOffer.reject_reason = '';
      httpServiceCustomer.customerService
        .updateOffer(this.newOffer, Cookies.get("token"))
        .then(function (response) {
          return response;
        })
        .catch((error) => {
          this.error = { code: error.response.code };
          // this.showModalPopup("modal_popup_loading", false);
          this.showModalPopup("modal_popup_info", true);
        })
        .then((response) => {
          if (response.status == 200) {
            this.newOffer = response.data;
            this.error = null;
            this.successMessage = this.$t("modifiyDataSucceess");
            // this.resetOfferDetails();
            // this.showModalPopup("modal_popup_loading", false);
            this.showModalPopup("modal_popup_info", true);
          } else {
            this.error = {
              code: response.data.code,
              description: "Error modifying offer",
            };
          }
        });
    },
    getOfferDetails(offerId) {
      // this.showModalPopup("modal_popup_loading", true);

      httpServiceCustomer.customerService
        .getOfferDetails(offerId, Cookies.get("token"))
        .then(function (response) {
          return response;
        })
        .then((response) => {
          if (response.status == 200) {
            this.newOffer = response.data;
            this.discountValue = this.newOffer.deduction !== 0 ? Number(this.newOffer.deduction) : Number(this.newOffer.discount);
            this.isDiscount = this.newOffer.discount !== 0
            this.isDeduction = this.newOffer.deduction !== 0
            this.period.startDate = [moment(this.newOffer.startDate)];
            this.period.endDate = [moment(this.newOffer.endDate)];
            this.period.validity_start_date = [moment(this.newOffer.validity_start_date)];
            this.period.validity_end_date = [moment(this.newOffer.validity_end_date)];
            this.error = null;
            // this.showModalPopup("modal_popup_loading", false);
          } else {
            this.error = {
              code: response.data.code,
            };
          }
        })
        .catch((error) => {
          this.error = { code: error.response.code };
          // this.showModalPopup("modal_popup_loading", false);
        });
    },
    uploadFile() {
      let input = this.$refs.fileInput1;
      let file = input.files;
      if (file && file[0]) {
        let readerOffer = new FileReader();
        readerOffer.onload = (e) => {
          if (!e) {
            this.newOffer.image = btoa(readerOffer.content);
          } else {
            this.newOffer.image = btoa(e.target.result);
          }
        };
        // reader.readAsDataURL(file[0]);
        if (readerOffer.readAsBinaryString) {
          readerOffer.readAsBinaryString(file[0]);
        } else {
          alert("This browser does not support HTML5.");
        }

        let reader = new FileReader();
        reader.onload = (e) => {
          this.previewImage = e.target.result;
        };
        reader.readAsDataURL(file[0]);
        if (reader.readAsBinaryString) {
        } else {
          alert("This browser does not support HTML5.");
        }
        // this.$emit("input", file[0]);
      }
    },
    resetOfferDetails() {
      this.newOffer = {
        type: "OFFER",
        currency: "lei",
        deduction: 0,
        description:
          "",
        discount: "",
        location: "",
        person: this.user.person,
        name: "",
        price: 0,
        measure_unit: "buc",
        image: null
      };
      this.previewImage = null;
      this.discountValue = 0;
      this.isDiscount = true,
        this.isDeduction = false,
        this.period = {
          endDate: [moment()],
          startDate: [moment()],
          validity_end_date: [moment()],
          validity_start_date: [moment()],
        };

    },
    openOfferDetails(offer) {
      this.selectedOfferId = offer.id;
      this.selectedOffer = offer;
      this.showModalPopup("modal_popup_offer", true);
    },
    startDateSelected(value) {
      this.period.startDate = value;
    },
    endDateSelected(value) {
      this.period.endDate = value;
    },
    validity_start_dateSelected(value) {
      this.period.validity_start_date = value;
    },
    validity_end_dateSelected(value) {
      this.period.validity_end_date = value;
    },
  },
  watch: {
    isDiscount: function (val) {
      this.isDiscount = val;
      this.isDeduction = !this.isDiscount;
    },
    isDeduction: function (val) {
      this.isDeduction = val;
      this.isDiscount = !this.isDeduction;
    },
  },
  mounted(){
    if (this.$route.params.offer && this.$route.params.offer !== undefined && this.$route.params.offer !== "undefined" && this.$route.params.offer !== null) {
      this.getOfferDetails(this.$route.params.offer);
    }
  },
  created() {
    this.user = this.getUser();
    this.newOffer.person = this.user.person;
  },

};
</script>
<style scoped src="@/assets/styles/beneficiary.css">

</style>
<style scoped>
small {
  font-family: "Raleway";
  font-style: normal;
  font-weight: 600;
  font-size: 13px;
  line-height: 15px;
  text-transform: capitalize;

  /* Primary 2 */

  color: #2d3736;
}
select {
  height: 40px;
  border: 1px solid #DEDEDE;
}

.multiselect {
  border: 1px solid #d8d8d8;
  background: #f1f1f1 !important;
  height: 40px !important;


}

.multiselect__input {
  font-size: 15px !important;
}
</style>
<style>
.vue-daterange-picker {
  width: 100%;
}
.vue-daterange-picker .reportrange-text {
  border: 1px solid #DEDEDE;
  border-radius: 0;
  height: 40px;
  padding: 6px 10px;
}
</style>